// extracted by mini-css-extract-plugin
module.exports = {"app-font-size":"16","breakpoint":"breakpoint","number-lines":"number-lines","zoomControls":"CpEfBg","buttonShare":"Ijshvz","zoomIcon":"_9Upbrr","disabled":"hT0C5E"};